// axios
import axios from "axios";
import { generateSign } from './sign'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
        config.headers['_app_sign'] = generateSign( config.data || config.params,!!config.params)
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export default service;